import { render, staticRenderFns } from "./Assembly.vue?vue&type=template&id=f76005e2&lang=pug&"
import script from "./Assembly.vue?vue&type=script&lang=ts&"
export * from "./Assembly.vue?vue&type=script&lang=ts&"
import style0 from "./Assembly.vue?vue&type=style&index=0&id=f76005e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports